import {FormModel} from "../../../../models/forms/form.model";
import {ILoginFormFields} from "./login-form-fields.interface";
import {FormFields} from "../../../../models/forms/form-field.interface";
import {IServiceFactory} from "../../../service-factory.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {DotRezDomainCodes} from "../../../dot-rez-api/data-contracts/enums/domain-codes.enum";

export interface LoginFormModelOptions {
    domain: DotRezDomainCodes;
    getUserNameFieldLabel?: () => string;

}
export class LoginFormModel extends FormModel<ILoginFormFields> {
    constructor(services: IServiceFactory, private readonly options: LoginFormModelOptions) {
        super(services);
        makeObservable<this, '_isLoginInProgress'>(this, {
            _isLoginInProgress: observable.ref
        })
    }
    protected _createFields(): FormFields<ILoginFormFields> {
        const language = this.services.language;
        return {
            userName: this._createField({
               fieldName: this.options?.getUserNameFieldLabel ?? (()  => 'E-mail')
            }),
            password: this._createField({
                fieldName: () => language.translate('Password')
            }),
            rememberMe: this._createField<boolean>({
                fieldName: () => language.translate('Remember me'),
                defaultValue: false,
                isRequired: false
            }),
            domain: this._createField<DotRezDomainCodes>({
                fieldName: () => language.translate('Domain'),
                defaultValue: this.options.domain,
                isRequired: true,
            })
        };
    }

    private _isLoginInProgress: boolean = false;
    get isLoginInProgress(): boolean {
        return this._isLoginInProgress;
    }
    private set isLoginInProgress(value: boolean) {
        runInAction(() => this._isLoginInProgress = value);
        this._isLoginInProgress = value;
    }

    async executeLogin(): Promise<void> {
        if(this.activateErrorsValidation().length > 0) {
            return;
        }

        try {
            this.isLoginInProgress = true;
            await this.services.user.loginWithCredentials({
                userName: this.fields.userName.value!,
                password: this.fields.password.value!,
                domain: this.options.domain,
                rememberMe: this.fields.rememberMe.value ?? false
            })
        } finally {
            this.isLoginInProgress = false;
        }

    }
}
